
  import { Component, Prop, Vue } from "vue-property-decorator";

  import CustomisedcontractorRequestCard from "@/components/card/CustomisedcontractorRequestCard.vue";
  import CollapsibleDescription from '@/components/common/CollapsibleDescription.vue';
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import CardBodyItemSkill from "@/components/card/CardBodyItemSkill.vue";

  import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
  import Badge from "@/components/common/Badge.vue";
  import CustomRequestModal from "@/components/requests/CustomRequestModal.vue";
  import CustomRequestActions from "@/components/requests/CustomRequestActions.vue";
  import { customRequestSkillsNumber } from "@/data/skillChipsNumber";
  import CollapsibleDescriptionLength from "@/entities/CollapsibleDescriptionLength";
  import SuitableResources from "@/components/requests/SuitableResources.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import TabNotificationBubble from "@/components/common/TabNotificationBubble.vue";
  import { Custom_Request, Skill, Contractor } from "@/generated/graphql";
  import S3Image from "@/components/common/s3-image.vue";
  import GET_SUITABLE_RESOURCES_CONTRACTOR from "@/apollo/requests/GetSuitableResourcesContractor.gql";
  import GET_USER_BY_EMAIL from "@/apollo/profile/GetUserByEmail.gql";
  import { User, Contractor_Bool_Exp } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";
  import Chip from "@/components/filters/Chip.vue";
  import HeartIcon from "@/components/icons/HeartIcon.vue";
  import ContractorRating from "@/components/rating/ContractorRating.vue";
  import EmployeeTag from "@/components/employee/EmployeeTag.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import ToggleFavorite from "@/components/favorite/ToggleFavorite.vue";

  interface ResourceQueryArgs {
    where: Contractor_Bool_Exp,
    companyId: string,
    requesterId: string,
  }

  @Component({
    components: {
      SuitableResources,
      CustomisedcontractorRequestCard,
      CollapsibleDescription,
      CardBodyItem,
      CardBodyItemSkill,
      UiButton,
      ItemChipsWithMore,
      TabNotificationBubble,
      Badge,
      CustomRequestModal,
      CustomRequestActions,
      S3Image,
      Chip,
      HeartIcon,
      ContractorRating,
      EmployeeTag,
      LoadingOverlay,
      ToggleFavorite
    },
    apollo: {
      suitableContractors: {
        query: GET_SUITABLE_RESOURCES_CONTRACTOR,
        variables(): ResourceQueryArgs {

          const exclude = !this.excludeResourceUserId ? {} : {
            id: {
              _neq: this.excludeResourceUserId,
            },
          };

          return {
            companyId: this.request.company_id,
            requesterId: this.request.created_by.id,
            where: {
              _and: [
                exclude,
                {
                  user: {
                    profile: {
                      skills: {
                        skill_id: {
                          _in: this.skillIds,
                        },
                      },
                    },
                  }
                },
              ],
            },
          };
        },
        update(data) {
          let suggested = data.contractor.filter((contractor: Contractor) => {
            return contractor.user.contracts.length > 0;
          });
          return suggested;
        },
      },
    },
  })

  export default class SuggestedResources extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly request!: Custom_Request;

    suitableResources: User[] = [];
    routes = RouteNames;
    favoriteContractor: boolean = false;
    contractors:Contractor[] = [];
    managerHasAccess: boolean[] = [];
    loading:boolean = false;
    suitableContractors: Contractor[] = [];
    currentUser:User = undefined;

    created(): void {
      this.currentUser = Vue.prototype.$currentUser;
    }

    get skillIds(): number[] {
      if (!this.requestSkills) {
        return [];
      }
      return this.requestSkills.map(({ id }: Skill) => id);
    }

    get requestSkills(): Skill[] {
      let req: any = this.request;
      if (!req.skills) {
        return [];
      }
      return req.skills.map(({ skill }) => skill);
    }

    get excludeResourceUserId(): string {
      return this.request.project_activity?.contractor?.user_id;
    }

    modalShown = false;
    collapsibleDescriptionLength = CollapsibleDescriptionLength;
    skillsNumber = customRequestSkillsNumber;

    get defaultInitialsClasses(): string {
      return "inline-flex h-6 w-6 rounded-lg items-center justify-center";
    }

    get defaultImageClasses(): string {
      return "inline-block rounded-lg object-cover object-center";
    }

    get avatarStyleClasses(): Record<string, boolean> {
      return {
        ["h-20 w-20"]: Boolean("h-16 w-16"),
        ["border border-primary"]: false,
      };
    }

    get bgStyle(): object {
      return {
        background: "#1A7BEE"
      };
    }

    companyIds(): string {
      return this.request.company_id
    }

    toggleRequestModal(): void {
      this.modalShown = !this.modalShown;
    }

    handleRefetch(): void {
      this.$apollo.queries.suitableContractors.refetch();
    }

    getFormattedNumber(num: any): number {
      if (!num) {
        return 0;
      }
      return num;
    }

    getFullLocation(city: string, country: string): string {
      if (!city && !country) {
        return "";
      } else if (!city && country) {
        return country;
      } else if (city && !country) {
        return city;
      }
      return city + ", " + country;
    }

    getBusinessName(user:User):string {
      if (!user.contracts) {
        return "";
      }
      if(user.contracts[0] === undefined) {
        return "";
      }
      return user.contracts[0].company.business_name;
    }

    getIsAdminFav(user: User): boolean {
      var isFav = false;
      user.favorited_by_users.forEach(fav_by => {
        if (fav_by.favorited_by_id === this.request.company.admins[0].user_id) {
          isFav = true
        }
      })
      return isFav;
    }

    getIsEmployeeTagShown(contractor:Contractor): boolean {
      if (!contractor) {
        return false;
      }

      const { deleted, approved } = contractor;

      return !deleted && approved;
    }

    getContractorInitials(user:User): string {
      return `${user.given_name![0]}${user.family_name![0]}`;
    }

    getContractorFullName(user:User): string {
      return `${user.given_name} ${user.family_name}`;
    }
  }
